var _Path, _Path2, _Path3, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgCatBackground = function SvgCatBackground(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "url(#cat-background_svg__a)",
    strokeWidth: 2,
    d: "M19 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#cat-background_svg__b)",
    d: "M8 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "url(#cat-background_svg__c)",
    d: "M5.414 18c-.89 0-1.337-1.077-.707-1.707l3.586-3.586a1 1 0 0 1 1.414 0l2.586 2.586a1 1 0 0 0 1.414 0l1.503-1.503a1 1 0 0 1 1.488.082l2.002 2.503A1 1 0 0 1 17.92 18z"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "cat-background_svg__a",
    x1: 6.825,
    x2: 8.471,
    y1: 4,
    y2: 19.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FCF17B"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#E19010"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "cat-background_svg__b",
    x1: 6.85,
    x2: 7.312,
    y1: 7,
    y2: 10.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FCF17B"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#E19010"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "cat-background_svg__c",
    x1: 6.612,
    x2: 6.86,
    y1: 12,
    y2: 17.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FCF17B"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#E19010"
  })))));
};
export default SvgCatBackground;